import React from "react";
import { formatDate } from "../../../../utils";
export default function AdminFormalityUserCard({ user, onBtnMessageClick = null }) {
  if (!user) return null;
  return (
    <div className="card mb-3">
      <div className="card-header  px-2 d-flex justify-content-between align-items-center">
        <strong>Client</strong>

      </div>
      <div className="card-body px-2">
        {/* IDENTITÉ */}
        <div className="mb-0">
          <strong>
            {user.userCivility} {user.userFirstname} {user.userName}
          </strong>
          {user.userCompName && (
            <div className="text-muted">{user.userCompName}</div>
          )}
        </div>
        {/* COORDONNÉES */}
        <table className="table table-sm mb-3">
          <tbody>
            <tr>
              <td className="px-0">
                <small>Téléphone<br /></small>
                {user.userPhone}
              </td>
            </tr>
            <tr>
              <td className="px-0">
                <small>Email<br /></small>
                {user.userEmail}
              </td>
            </tr>
            <tr>
            </tr>
            <tr>
              <td className="px-0">
                <small>Adresse<br /></small>
                {user.userAddress}<br />
                {user.userPostcode} {user.userCity}<br />
                {user.userCountry}
              </td>
            </tr>
          </tbody>
        </table>
        {/* INFOS LÉGALES */}
        {(user.userSiret || user.userVatNumber) && (
          <>
            <h6 className="text-muted">Informations légales</h6>
            <table className="table table-sm mb-3">
              <tbody>
                <tr>
                  <th className="text-muted">Forme juridique</th>
                  <td>{user.userLegalForm || "-"}</td>
                </tr>
                <tr>
                  <th className="text-muted">SIRET</th>
                  <td>{user.userSiret || "-"}</td>
                </tr>
                <tr>
                  <th className="text-muted">TVA</th>
                  <td>{user.userVatNumber || "-"}</td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        {/* META */}
        <div className="small text-muted">
          {/* 
          <div>Créé le : {formatDate(user.userCreatedAt)}</div>
          <div>Dernière connexion : {formatDate(user.userLastConnexionAt)}</div>
          */}
          {onBtnMessageClick &&
            <div className="text-end">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={onBtnMessageClick}
              >
                Envoyer un message
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
